// TODO: Move
import React from 'react'
import CurrencyFormatter from '../../formatters/CurrencyFormatter'
import Link from 'next/link'
import { Route } from '../../../routers/routes'
import MomentFormatter from '../../formatters/MomentFormatter'
import { InstrumentAPI } from '../../../data/market'
import Styling from '../../styling'

export default function PortfolioTransactionListItem(props) {
  const { item } = props
  return (
    <div key={item.identifier} className="p-4">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-8 text-sm">
          Bought {item.quantity} shares of&nbsp;
          <Link className="underline" href={Route.instrumentDetail(item.instrument)}>{item.instrument.name}</Link>&nbsp;
          at <CurrencyFormatter value={item.price_per_share} currency={InstrumentAPI.getCurrencyName(item.country_id)} /> per share
        </div>
        <div className={`col-span-4 text-right ${Styling.sizes.xs.default}`}>
          <MomentFormatter date={item.transaction_at} fromNow />
        </div>
      </div>
    </div>
  )
}
